import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import ActivityLog from '../../ActivityLog';
import * as Common from '../../Common';
import Dialog from '../../Dialog';
import DialogYesNo from '../../Dialog_Yes_No';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from '../../Picklist';
import Tran_data_unlock_request from '../../Tran_data_unlock_request';

const Currency_change = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const branchDisable = sessionStorage.getItem('branchDisable');

    const [userRight, setUserRight] = useState([]);
    const [onceRun, setOnceRun] = useState(false);
    const [scrMode, setScrMode] = useState("");

    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isErrBox, setErrBox] = useState(false);
    const [errText, setErrText] = useState("");

    const [innerData, setInnerData] = useState([]);
    const [headerData, setHeaderData] = useState([]);

    const [location, setLocation] = useState('');
    const [locationCode, setLocationCode] = useState(0);
    const [radioType, setRadioType] = useState('N');
    const [currencyChangeLocation, setCurrencyChangeLocation] = useState(null);
    const [currencyChangeCurrency, setCurrencyChangeCurrency] = useState(null);
    const [currencyCode, setCurrencyCode] = useState('');
    const [currencyChangeFromSrno, setCurrencyChangeFromSrno] = useState('');
    const [currencyChangeToSrno, setCurrencyChangeToSrno] = useState('');
    const [currencyChangeDate, setCurrencyChangeDate] = useState(new Date());
    const [currencyChangeFromDate, setCurrencyChangeFromDate] = useState(new Date());
    const [currencyChangeToDate, setCurrencyChangeToDate] = useState(new Date());
    const [currencyChangeType, setCurrencyChangeType] = useState('IN');
    const [currencyChangeDeno, setCurrencyChangeDeno] = useState('');
    const [currencyChangeQuantity, setCurrencyChangeQuantity] = useState('');
    const [srNo, setSrNo] = useState(0);
    const [lineNo, setLineNo] = useState(0);
    const [counter, setCounter] = useState(0);

    const [viewDate, setViewDate] = useState('');
    const [editReqDate, setEditReqDate] = useState('');
    const [viewSrno, setViewSrno] = useState(0);
    const currentDate = new Date();
    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });
    const [inOutIsdAmountList, setInOutIsdAmountList] = useState([]) //{ isd: '', totalInAmount: 0, TotalOutAmount: 0 }
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [showActivityLog, setShowActivityLog] = useState(false);

    var msg = [], i = 0;
    const [unlockRequestType, setUnlockRequestType] = useState("");
    const [isBranchDisableForAddNew, setIsBranchDisableForAddNew] = useState("");
			


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setCurrencyChangeLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'CURRENCY_CHANGE'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);


    const handleChangeLocation = (value) => {
        setCurrencyChangeLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        setLocation(loc[2]);
        sessionStorage.activeBranch = loc[1];
        setIsBranchDisableForAddNew(loc[9]);
    }


    const handleCurrencyChange = (value) => {
        setCurrencyChangeCurrency(value);
        const currency = value.id.split('^');
        setCurrencyCode(currency[1]);
    }


    const list = () => {
        $(".loader").show();
        if (!currencyChangeLocation || (radioType === 'S' && !currencyChangeFromSrno) || (radioType === 'S' && !currencyChangeToSrno) ||
            (radioType === 'D' && !currencyChangeFromDate) || (radioType === 'D' && !currencyChangeToDate)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (!currencyChangeLocation ? " Location." : '');
            msg[i++] = (radioType === 'S' && !currencyChangeFromSrno ? " From Srno." : '');
            msg[i++] = (radioType === 'S' && !currencyChangeToSrno ? " To Srno." : '');
            msg[i++] = (radioType === 'D' && !currencyChangeFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'D' && !currencyChangeToDate ? " To Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                location: locationCode,
                filterRadioType: radioType,
                filterFromSrno: currencyChangeFromSrno,
                filterToSrno: currencyChangeToSrno,
                filterFromDate: Common.dateYMD(currencyChangeFromDate),
                filterToDate: Common.dateYMD(currencyChangeToDate),
            }
            Common.callApi(Common.apiCurrencyChange, [sid, 'list', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setHeaderData(resp);
            });
        }
    }


    const addNew = () => {
        var date = Common.dateYMD(currencyChangeDate);
        var today = Common.dateYMD(new Date());
        if (!currencyChangeLocation || !currencyChangeDate) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (!currencyChangeLocation ? " Location." : '');
            msg[i++] = (!currencyChangeDate ? " Date." : '');

            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (date > endDate || date < startDate) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0010"));
        } else if (date > today) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0011"));
        } 
        else if (+isBranchDisableForAddNew === 1) {
            setMsgBox(true);
            setMsgText("Branch Disable .New Entry not Allowed.");
        }
        else {
            if (date == today) {
                addNewFormResetFields();
            } else {
                const obj = {
                    billdate: date,
                    location: locationCode,
                    type: 'CNCHNG'
                }
                Common.callApi(Common.apiDataUnlock, [sid, 'addnewunlock', JSON.stringify(obj)], result => {
                    let resp = JSON.parse(result);
                    if (resp.msg === "1") {
                        addNewFormResetFields();
                    } else {
                        setMsgBox(true);
                        setMsgText(Common.getMessage("MSG0012"));
                    }
                });
            }
        }
    }

    const addNewFormResetFields = () => {
        setScrMode('A');
        setCurrencyChangeCurrency(null);
        setCurrencyChangeType('IN');
        setCurrencyChangeDeno('');
        setCurrencyChangeQuantity('');
        setInnerData([]);
        setViewDate(Common.dateDMY(currencyChangeDate));
        setInOutIsdAmountList([]);
        setSrNo(0);
    }

    const addDetail = async () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (!currencyChangeCurrency || !currencyChangeDeno || !currencyChangeQuantity) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (!currencyChangeCurrency ? " Currency." : '');
            msg[i++] = (!currencyChangeDeno ? " Denomination." : '');
            msg[i++] = (!currencyChangeQuantity ? " Quantity." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const prd_amount = currencyChangeDeno * currencyChangeQuantity;
            const obj = {
                unique_no: Common.getRandomString(5),
                prd_line_no: innerData.length + 1,
                prd_location: locationCode,
                prd_type: 'CNCHNG',
                prd_isd: currencyCode,
                prd_date: srNo > 0 ? viewDate : Common.dateYMD(currencyChangeDate),
                prd_product: 'CN',
                prd_in_type: currencyChangeType,
                prd_deno: currencyChangeDeno,
                prd_qty: currencyChangeQuantity,
                prd_srno: srNo,
                prd_amount: prd_amount,
                del: 'Y',
            };
            $(".loader").hide();
            if (currencyChangeType === "IN") {
                handleInOutAmount(currencyCode, currencyChangeType, prd_amount);
            }
            else if (currencyChangeType === "OUT") {
                let stock = await Common.checkAvailableStock(obj, innerData);
                if (!stock) {
                    setMsgBox(true);
                    setMsgText("Not able to add " + obj.prd_isd + ", stock getting negative.");
                    return;
                } else {
                    handleInOutAmount(currencyCode, currencyChangeType, prd_amount);
                }
            }
            setInnerData(Common.arrayAddItem(innerData, obj));
            const obj2 = {
                TabType: "Product",
                ALineNo: tranAuditTrail.length + 1,
                AType: "A",
                TLoc: locationCode,
                TType: 'CNCHNG',
                ProductType: currencyChangeType,
                ISD: currencyCode,
                Deno: currencyChangeDeno,
                Quantity: currencyChangeQuantity,
                ProductAmount: prd_amount,
            }
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
            }
            // console.log(innerData);
            setLineNo(lineNo + 1);
            setCurrencyChangeCurrency(null);
            setCurrencyChangeType('IN');
            setCurrencyChangeDeno('');
            setCurrencyChangeQuantity('');
        }
    }


    const deleteItem = (res) => {
        const itemToDelete = innerData.find(item => item.unique_no === res);
        if (itemToDelete) {
            const formattedItem = {
                TabType: "Product",
                ALineNo: tranAuditTrail.length + 1,
                AType: "D",
                TLoc: itemToDelete.prd_location,
                TType: 'CNCHNG',
                ProductType: itemToDelete.prd_in_type,
                ISD: itemToDelete.prd_isd,
                Deno: itemToDelete.prd_deno,
                Quantity: itemToDelete.prd_qty,
                ProductAmount: itemToDelete.prd_amount,

            }
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
            }
        }
        setInnerData(Common.arrayRemoveItem(innerData, 'unique_no', res.unique_no));
        setCounter(counter + 1);
        let newInOutIsdAmountList = inOutIsdAmountList.map((data) => {
            if (data.isd === res.prd_isd) {
                return {
                    ...data,
                    totalInAmount: res.prd_in_type.trim() === "IN" ? data.totalInAmount - res.prd_amount : data.totalInAmount,
                    TotalOutAmount: res.prd_in_type === "OUT" ? data.TotalOutAmount - res.prd_amount : data.TotalOutAmount
                }
            } else {
                return data;
            }
        })
        console.log(newInOutIsdAmountList);
        setInOutIsdAmountList(newInOutIsdAmountList);
    }


    const saveData = () => {
        $(".loader").show();
        if (innerData.length < 1) {
            $(".loader").hide();
            setMsgText('Empty List!');
            setMsgBox(true);
        } else {
            //if IN OUT amount is not equal than return a message 
            let inOutAmount = checkInOutAmount();
            console.log(inOutAmount);
            if (inOutAmount.length > 0) {
                $(".loader").hide();
                setMsgText(inOutAmount);
                setMsgBox(true);
                return;
            }
            const obj = {
                location: locationCode,
                srno: srNo,
                date: srNo > 0 ? viewDate : Common.dateYMD(currencyChangeDate),
                data: innerData,
                type: 'CNCHNG',

                filterRadioType: radioType,
                filterFromSrno: currencyChangeFromSrno,
                filterToSrno: currencyChangeToSrno,
                filterFromDate: Common.dateYMD(currencyChangeFromDate),
                filterToDate: Common.dateYMD(currencyChangeToDate),
            };
            Common.callApi(Common.apiCurrencyChange, [sid, 'save', JSON.stringify(obj), JSON.stringify(tranAuditTrail)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                if (resp.msg !== "") {
                    setMsgBox(true);
                    setMsgText(resp.msg);
                } else {
                    setScrMode('');
                    setTranAuditTrail([]);
                    setHeaderData(resp.curarray);
                }
            });
            if (scrMode == 'E' && unlockRequestType !== "SELF") {
                const obj = {
                    srno: srNo,
                    type: 'CNCHNG',
                    status: 'E',
                    currentDate: Common.dateYMD(currentDate),
                    pageright: 'CURRENCY_CHANGE'
                }
                Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                    console.log(result);
                })

            }
        }
    }

    //check IN OUT Amount for Each currency is same or not
    function checkInOutAmount() {
        let res = inOutIsdAmountList.map((data) => {
            if (data.totalInAmount != data.TotalOutAmount) {
                return `For Currency ${data.isd} IN and OUT Amount is not same. <br>`;
            } else {
                return '';
            }
        })
        return res.join('');

    }


    const viewList = (hdrSrno, location, type, date, vdate) => {
        $(".loader").show();
        setSrNo(hdrSrno);
        setScrMode('Q');
        setViewDate(vdate);
        setEditReqDate(date);
        setViewSrno(hdrSrno);
        const obj = {
            srno: hdrSrno,
            location: location,
            type: type,
        }
        Common.callApi(Common.apiCurrencyChange, [sid, 'view', JSON.stringify(obj)], (result) => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            if (resp.msg === 'MSG0000') {
                $(".loader").hide();
                setInnerData(resp.currencyList);
                setLineNo(resp.maxlineno);
                setLocationCode(resp.location);
                setLocation(resp.locationname);
            }
        });
    }


    const cancelConfirm = () => {
        if (scrMode === "A" || scrMode === "E") {
            setMsgTextYN('Do you really want to exit ?');
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
        setInnerData([])
    }


    // const editData = () => {
    //     setScrMode("E");
    // }

    const btnEditRequest = () => {
        const currDate = new Date();
        const newDate = editReqDate.split('/');

        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0]
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newViewDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;

        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));

        console.log(differenceInDays);

        const obj = {
            srno: viewSrno,
            type: 'CNCHNG',
            pageright: 'CURRENCY_CHANGE',
            location: locationCode
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setScrMode('E');
                handleInOutIsdAmountAfterEdit();//update inOutIsdAmountList array;
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'CNCHNG', trannumber: viewSrno, location: locationCode, tranDate: Common.dateYMD(currDate) });
            }
        })


    }
    //when we click on the edit button than newInOutIsdAmountList will update
    function handleInOutIsdAmountAfterEdit() {
        let newInOutIsdAmountList = [];
        innerData.forEach((innerObj) => {
            let index = newInOutIsdAmountList.findIndex((inOutAmountObj) => inOutAmountObj.isd === innerObj.prd_isd)
            if (index != -1) {
                let newobj = {
                    ...newInOutIsdAmountList[index],
                    totalInAmount: innerObj.prd_in_type.trim() === "IN" ? newInOutIsdAmountList[index].totalInAmount * 1 + innerObj.prd_amount * 1 : newInOutIsdAmountList[index].totalInAmount * 1,
                    TotalOutAmount: innerObj.prd_in_type === "OUT" ? newInOutIsdAmountList[index].TotalOutAmount * 1 + innerObj.prd_amount * 1 : newInOutIsdAmountList[index].TotalOutAmount * 1
                }
                newInOutIsdAmountList[index] = newobj;
            } else {
                newInOutIsdAmountList.push({
                    isd: innerObj.prd_isd,
                    totalInAmount: innerObj.prd_in_type.trim() === "IN" ? innerObj.prd_amount * 1 : 0,
                    TotalOutAmount: innerObj.prd_in_type === "OUT" ? innerObj.prd_amount * 1 : 0
                });
            }

        })
        setInOutIsdAmountList(newInOutIsdAmountList);
    }

    //handle IN OUT amount in the list should be equal for each Corrency
    function handleInOutAmount(isd, type, amount) {
        // [{ isd: '', totalInAmount: 0, TotalOutAmount: 0 }]
        let isExist = false;
        let newInOutIsdAmountList = []
        newInOutIsdAmountList = inOutIsdAmountList.map((data) => {
            if (data.isd === isd) {
                isExist = true;
                return {
                    ...data,
                    totalInAmount: type.trim() === "IN" ? data.totalInAmount + amount : data.totalInAmount,
                    TotalOutAmount: type === "OUT" ? data.TotalOutAmount + amount : data.TotalOutAmount
                }
            } else {
                return data;
            }
        })
        if (!isExist && isd) {
            newInOutIsdAmountList = [...inOutIsdAmountList,
            {
                isd: isd,
                totalInAmount: type.trim() === "IN" ? amount : 0,
                TotalOutAmount: type === "OUT" ? amount : 0
            }]

        }
        console.log(newInOutIsdAmountList);
        setInOutIsdAmountList(newInOutIsdAmountList)
    }
    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "CNCHNG", trannumber: viewSrno, trancategory: "T", location: locationCode });
    }


    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Currency Change</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                {
                    scrMode === "" ?
                        <>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={currencyChangeLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleChangeLocation}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-4 col-6'>
                                    <Form.Group>
                                        <Row style={{ marginTop: "30px" }}>
                                            <Col>
                                                <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />
                                            </Col><Col>
                                                <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                            </Col><Col>
                                                <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    radioType === 'N' ?
                                        <>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Date<span className="text-danger">*</span></Form.Label>
                                                    <DatePicker className="form-control"
                                                        selected={currencyChangeDate}
                                                        minDate={new Date(startDate)}
                                                        maxDate={new Date(endDate)}
                                                        onChange={(date) => setCurrencyChangeDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        customInput={
                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </>
                                        :
                                        radioType === 'S' ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="text-danger">*</span></Form.Label>
                                                        <Form.Control value={currencyChangeFromSrno}
                                                            maxLength={20}
                                                            onChange={(e) => Common.validateNumValue(e.target.value, setCurrencyChangeFromSrno)}
                                                            placeholder="From" />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="text-danger">*</span></Form.Label>
                                                        <Form.Control value={currencyChangeToSrno}
                                                            maxLength={20}
                                                            onChange={(e) => Common.validateNumValue(e.target.value, setCurrencyChangeToSrno)}
                                                            placeholder="To" />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                            :
                                            radioType === 'D' ?
                                                <>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={currencyChangeFromDate}
                                                                onChange={(date) => setCurrencyChangeFromDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={currencyChangeToDate}
                                                                onChange={(date) => setCurrencyChangeToDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </>
                                                :
                                                null
                                }
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    {
                                        userRight.add === "1" && radioType === 'N' ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNew()}>Add New</Button> : null
                                    }
                                    &nbsp;
                                    {
                                        userRight.query === "1" && (radioType === 'S' || radioType === 'D') ?
                                            < Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => list()}>List</Button>
                                            : null
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                {userRight.edit === "1" ? <th></th> : null}
                                                <th>SrNo</th>
                                                <th>Date</th>
                                                {/* <th>Type</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                headerData.map((res) => (
                                                    <tr key={res.hdr_srno}>
                                                        {userRight.query === "1" ?
                                                            <td className="textCenter">
                                                                <span className="handCursor colorThemeBlue" onClick={() => viewList(res.hdr_srno, res.hdr_location, res.hdr_type, res.new_date, res.hdr_date)}>
                                                                    <FontAwesomeIcon icon={faEye} />
                                                                </span>
                                                            </td>
                                                            : null
                                                        }
                                                        <td>{res.hdr_srno}</td>
                                                        <td>{res.hdr_date}</td>
                                                        {/* <td>{res.hdr_type}</td> */}
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </>
                        :
                        <>
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={() => cancelConfirm()}>Back</Button>{' '}
                                    {
                                        (userRight.edit === "1" && scrMode === "Q") ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => btnEditRequest()}>Edit</Button>
                                        </> : null
                                    }
                                    {(userRight.edit === "1" && scrMode === 'Q') ? <>
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                            btnActivityLog()}>Activity Log</Button>&nbsp;
                                    </> : null
                                    }
                                    {
                                        (userRight.edit === "1" && scrMode === "E") || (userRight.add === "1" && scrMode === "A") ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>
                                        </> : null
                                    }
                                    {/* <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={exportFile}>Export</Button> */}
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>Srno : {srNo}</Form.Label>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>Location : {location}</Form.Label>
                                </Col>
                                <Col className='col-md-3 col-6'>
                                    <Form.Label>Date : {viewDate}</Form.Label>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            {
                                scrMode === "E" || scrMode === "A" ?
                                    <>
                                        <Row>
                                            <Col className='col-md-4 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Type<span className="text-danger">*</span></Form.Label>
                                                    <Form.Select value={currencyChangeType} onChange={e => setCurrencyChangeType(e.target.value)}
                                                        required>
                                                        <option value="IN">IN</option>
                                                        <option value="OUT">OUT</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-4 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Currency<span className="text-danger">*</span></Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={currencyChangeCurrency}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={(search) => Picklist.fetchCurrencyAllowedPicklist(search, 'CN')} // location = 1 , 2
                                                        onInputChange={Picklist.handleInputChange}
                                                        onChange={handleCurrencyChange}
                                                    >
                                                    </AsyncSelect>
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-4 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Denomination<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        value={currencyChangeDeno}
                                                        onChange={(e) => Common.validateNumValue(e.target.value, setCurrencyChangeDeno)}
                                                        maxLength={6}
                                                        placeholder="Denomination" />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className='col-md-4 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Quantity<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control
                                                        value={currencyChangeQuantity}
                                                        onChange={(e) => Common.validateNumValue(e.target.value, setCurrencyChangeQuantity)}
                                                        maxLength={Common.maximumLength}
                                                        placeholder="Quantity" />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: "30px" }}>
                                            <Col className='col-md-3 col-6'>
                                                {
                                                    userRight.add === "1" ?
                                                        <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addDetail()}>Add</Button> : null
                                                }
                                            </Col>
                                        </Row>
                                    </> :
                                    null
                            }
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                {userRight.edit === "1" ? <th></th> : null}
                                                <th>Type</th>
                                                <th>Currency</th>
                                                <th>Denomination</th>
                                                <th>Quantity</th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                innerData.map((res) =>
                                                    <tr key={res.prd_line_no}>
                                                        {
                                                            userRight.delete === "1" ?
                                                                <td className="textCenter" >
                                                                    {
                                                                        scrMode === 'Q' || res.del === 'N' ? null :
                                                                            <>
                                                                                <span className="handCursor colorThemeBlue" onClick={() => deleteItem(res)} >
                                                                                    <FontAwesomeIcon icon={faTrash} />
                                                                                </span> {' '}
                                                                            </>
                                                                    }
                                                                </td>
                                                                : null
                                                        }
                                                        <td>{res.prd_in_type}</td>
                                                        <td>{res.prd_isd}</td>
                                                        <td>{res.prd_deno}</td>
                                                        <td>{res.prd_qty}</td>
                                                        <td>{res.prd_amount}</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={() => cancelConfirm()}>Back</Button>{' '}
                                    {
                                        (userRight.edit === "1" && scrMode === "Q") ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => btnEditRequest()}>Edit</Button>
                                        </> : null
                                    }
                                    {(userRight.edit === "1" && scrMode === 'Q') ? <>
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                            btnActivityLog()}>Activity Log</Button>&nbsp;
                                    </> : null
                                    }
                                    {
                                        (userRight.edit === "1" && scrMode === "E") || (userRight.add === "1" && scrMode === "A") ? <>
                                            <Button variant='outline-primary' size='sm' className='buttonStyle' onClick={() => saveData()}>Save</Button>
                                        </> : null
                                    }
                                    {/* <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={exportFile}>Export</Button> */}
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>&nbsp;</Row>
                            <Row>&nbsp;</Row>
                            <Row>&nbsp;</Row>
                        </>
                }
            </Container>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
                <Dialog isOpen={isErrBox} onClose={(e) => setErrBox(false)}>
                    {errText}
                </Dialog>
                <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />
            </div>
        </>
    )
}

export default Currency_change;
